<template>
  <transition name="scroll-y-transition" appear>
    <v-sheet color="adawhite" style="min-height:100vh;box-sizing:border-box;">
      <v-container
        style="max-width:750px;"
        :class="this.$vuetify.breakpoint.xs ? '' : 'pt-16'"
      >
        <GenericNav />

        <v-container>
          <v-row>
            <v-col cols="12" lg="6">
              <p class="text-h4 adaprimary--text">Tervetuloa Kanakoriin!</p>
              <p class="adaprimary--text">
                Bugeista ja kehitysehdotuksista voi ilmoittaa sähköpositse
                ruokalistat@kanakori.fi tai klikkaamalla oikeassa reunassa
                olevaa "Palaute"-nappulaa.
              </p>
            </v-col>
            <v-col cols="12" lg="6">
              <p
                :class="
                  autosetup
                    ? 'text-h6 adaprimary--text'
                    : 'text-h6 font-weight-bold adaprimary--text'
                "
              >
                {{ autosetup ? "" : "1. " }}Millä nimellä kutsumme sinua?
              </p>
              <v-form @submit.prevent="_step1">
                <!-- style="box-sizing:border-box;max-width:326px;" -->
                <div>
                  <v-text-field
                    v-model="username"
                    filled
                    rounded
                    color="nsecondary"
                    label="Etunimi"
                    :error-messages="unerror"
                  />
                </div>

                <div v-if="!autosetup">
                  <p class="text-h6 font-weight-bold adaprimary--text">
                    2. Valitse ruokalista
                  </p>
                  <v-row class="adawhite" style="max-width:350px;">
                    <v-col cols="12" v-for="(list, i) in Lists" :key="i">
                      <v-btn
                        large
                        block
                        color="adaprimary"
                        class="adawhite--text"
                        rounded
                        @click="_submit(list.sub)"
                      >
                        {{ list.friendlyname }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
                <v-btn
                  v-else
                  large
                  block
                  color="adaprimary"
                  class="adawhite--text"
                  rounded
                  type="submit"
                >
                  Jatka
                </v-btn>
              </v-form>
            </v-col>
          </v-row>
          <v-alert v-if="SDKError" type="error" rounded="lg">
            SDK-virhe: {{ SDKError }}
          </v-alert>
        </v-container>
      </v-container>
      <GenericFooter />
    </v-sheet>
  </transition>
</template>

<script>
import { mapState } from "vuex";
import store from "@/store";
import router from "@/router";
import GenericNav from "@/components/layout/GenericNav";
import GenericFooter from "@/components/layout/GenericFooter";

export default {
  name: "Home",
  components: {
    GenericNav,
    GenericFooter
  },
  data: () => {
    return {
      username: "",
      unerror: "",
      error: ""
    };
  },
  watch: {
    username(val) {
      // TODO
      store.commit("appconfig/rawSetUsername", val);
    }
  },
  methods: {
    _step1() {
      if (this.autosetup) this._submit(this.autosetup);
      document.activeElement.blur();
    },
    _submit(sub) {
      this.unerror = "";
      if (!sub) return (this.error = "Valitse lista");
      // TODO
      if (!this.username) return (this.unerror = "Ei voi olla tyhjä!");
      store.dispatch("listconfig/chooseList", sub);
      // TODO
      store.commit("appconfig/setShowOnboarding", false);
      router.replace("/");
    }
  },
  computed: {
    notProd() {
      return process.env.NODE_ENV !== "production";
    },
    autosetup() {
      return this.$route.query.joinsub;
    },
    ...mapState({
      Lists: state => state.listconfig.all,
      SDKError: state => state.listconfig.sdkerror
    })
  },
  created() {
    store.dispatch("listconfig/getListinfos");

    this.username = localStorage.getItem("userfirstname");

    this.$nextTick(() => {
      if (localStorage.getItem("userfirstname") && localStorage.getItem("sub"))
        this._submit(localStorage.getItem("sub"));
    });
  }
};
</script>
